var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sh-button',{attrs:{"color":"secondary","aria-live":"polite","aria-label":_vm.copyTextLabel},on:{"click":_vm.handleCopyCode}},[_vm._v("\n  "+_vm._s(_vm.copyText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }